import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialsModule } from '@library/common/materials';
import { PipesModule } from '@library/core/pipes';

import { DefaultErrorComponent } from './default.error/default.error.component';
import { InputErrorsDirective } from './input-errors.directive';

@NgModule({
  imports: [
    CommonModule,
    MaterialsModule,
    PipesModule,
  ],
  declarations: [
     DefaultErrorComponent,
     InputErrorsDirective,
  ],
  exports: [
     DefaultErrorComponent,
     InputErrorsDirective,
  ],
})
export class ErrorsModule { }
